import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  show: boolean = false;

  // Reference count so overlapping loaders keep one continuous spinner
  // instead of flickering off when the first of them finishes.
  private pending = 0;

  showSpinner() {
    this.pending++;
    setTimeout(() => {
      this.show = this.pending > 0;
    }, 0)
  }
  hideSpinner() {
    this.pending = Math.max(0, this.pending - 1);
    setTimeout(() => {
      this.show = this.pending > 0;
    }, 0)
  }
}
